import { useCallback } from "react"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { Ch_updateProgressNoteAnamnesisInput } from "@/modules/patients/services/ch/__generated__/chUpdateProgressNoteAnamnesisMutation.graphql"
import { chUpdateProgressNoteAnamnesis } from "@/modules/patients/services/ch/chUpdateProgressNoteAnamnesisMutation"
import { De_updateProgressNoteAnamnesisInput } from "@/modules/patients/services/de/__generated__/deUpdateProgressNoteAnamnesisMutation.graphql"
import { deUpdateProgressNoteAnamnesis } from "@/modules/patients/services/de/deUpdateProgressNoteAnamnesisMutation"
import { Country } from "@/types/__generated__/union-types"

export function useUpdateProgressNoteAnamnesisMutation(
  country: Country,
): (
  input: Ch_updateProgressNoteAnamnesisInput & De_updateProgressNoteAnamnesisInput,
  handleComplete?: () => void,
) => void {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chUpdateProgressNoteAnamnesis
      case "DE":
        return deUpdateProgressNoteAnamnesis
    }
  })()

  const [commit] = useMutationWithErrorToast(mutation)

  return useCallback(
    (input: Ch_updateProgressNoteAnamnesisInput & De_updateProgressNoteAnamnesisInput, handleComplete?: () => void) => {
      commit({
        variables: { input },
        onCompleted: handleComplete,
      })
    },
    [commit],
  )
}
